/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Jobs_admin = {|
  +allJobs: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +status: string;
        +paymentTutor: number;
        +paymentInternal: number;
        +paymentExternal: number;
        +createdAt: ?any;
        +sessionCount: number;
        +averageTutorRating: ?number;
        +averageStudentRating: ?number;
        +acceptedJobOffer: {|
          +tutor: {|
            +fullname: string;
          |};
          +jobRequest: {|
            +student: {|
              +fullname: string;
            |};
            +subject: {|
              +description: ?string;
            |};
            +grade: {|
              +name: string;
              +gradeGroup: ?{|
                +name: string;
              |};
            |};
          |};
        |};
        +sessions: $ReadOnlyArray<{|
          +status: string;
          +rating: ?{|
            +studentRating: ?number;
            +studentComment: ?string;
            +tutorRating: ?number;
            +tutorComment: ?string;
          |};
          +timeSlot: {|
            +duration: {|
              +totalMinutes: number;
            |};
            +startDate: any;
          |};
        |}>;
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "count",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "cursor",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "RootArgument",
      "name": "isRecurring",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "status",
      "type": "[JobStatus]"
    },
    {
      "kind": "RootArgument",
      "name": "hasStudentRating",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasTutorRating",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "sessionStatus",
      "type": "[JobSessionStatus]"
    },
    {
      "kind": "RootArgument",
      "name": "requestType",
      "type": "[JobRequestType]"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": [
          "allJobs"
        ]
      }
    ]
  },
  "name": "Jobs_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "allJobs",
      "args": [
        {
          "kind": "Variable",
          "name": "hasStudentRating",
          "variableName": "hasStudentRating",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "hasTutorRating",
          "variableName": "hasTutorRating",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "isRecurring",
          "variableName": "isRecurring",
          "type": "Boolean"
        },
        {
          "kind": "Variable",
          "name": "requestType",
          "variableName": "requestType",
          "type": "[JobRequestType]"
        },
        {
          "kind": "Variable",
          "name": "sessionStatus",
          "variableName": "sessionStatus",
          "type": "[JobSessionStatus]"
        },
        {
          "kind": "Variable",
          "name": "status",
          "variableName": "status",
          "type": "[JobStatus]"
        }
      ],
      "concreteType": "JobConnection",
      "name": "__Jobs_allJobs_connection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "JobEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Job",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "sessionCount",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "paymentTutor",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "paymentInternal",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "paymentExternal",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdAt",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "status",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "averageTutorRating",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "averageStudentRating",
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "JobOffer",
                  "name": "acceptedJobOffer",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "Tutor",
                      "name": "tutor",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "fullname",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "JobRequest",
                      "name": "jobRequest",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "Student",
                          "name": "student",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "fullname",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "Subject",
                          "name": "subject",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "description",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "Grade",
                          "name": "grade",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "GradeGroup",
                              "name": "gradeGroup",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "alias": null,
                                  "args": null,
                                  "name": "name",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "JobSession",
                  "name": "sessions",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "JobSessionRating",
                      "name": "rating",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "studentRating",
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "studentComment",
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "tutorRating",
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "tutorComment",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "TimeSlot",
                      "name": "timeSlot",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "Duration",
                          "name": "duration",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "totalMinutes",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "startDate",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "endCursor",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/job/__generated__/Jobs_admin.graphql.js